import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { Trophy, PartyPopper, Home } from "lucide-react";

export default function ShakersThanksPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-[#e6f5f0] flex items-center justify-center p-4">
      <Card className="max-w-lg text-center overflow-hidden">
        <div className="bg-gradient-to-r from-amber-500 to-amber-600 p-8">
          <div className="flex justify-center gap-3">
            <Trophy className="h-12 w-12 text-white" />
            <PartyPopper className="h-12 w-12 text-white" />
          </div>
        </div>
        <CardContent className="p-8">
          <h1 className="text-2xl font-bold text-gray-800 mb-4">
            ¡Gracias por tu evaluación!
          </h1>
          <p className="text-gray-600 mb-6">
            Tu opinión es muy valiosa para reconocer a los compañeros que han demostrado 
            un espíritu innovador excepcional. Los resultados serán compartidos pronto.
          </p>
          <div className="p-4 bg-amber-50 rounded-lg mb-6">
            <p className="text-amber-800 text-sm">
              ¡Gracias por tu participación en los premios Valoriza Shakers de parte de los Spaceneers!
            </p>
          </div>
          <Button 
            onClick={() => navigate("/dashboard")}
            className="bg-[#009B77] hover:bg-[#008066]"
          >
            <Home className="h-4 w-4 mr-2" />
            Volver al Dashboard
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
